import React from 'react'

type Gap =
  | 'gap-0' // 0px
  | 'gap-px' // 1px
  | 'gap-0.5' // 2px
  | 'gap-1' // 4px
  | 'gap-1.5' // 6px
  | 'gap-2' // 8px
  | 'gap-2.5' // 10px
  | 'gap-3' // 12px
  | 'gap-3.5' // 14px
  | 'gap-4' // 16px
  | 'gap-5' // 20px
  | 'gap-6' // 24px

type Align =
  | 'items-center'
  | 'items-inherit'
  | 'items-start'
  | 'items-end'
  | 'items-end-safe'
  | 'items-center-safe'
  | 'items-baseline'
  | 'items-baseline-last'
  | 'items-stretch'
type Justify =
  | 'justify-between'
  | 'justify-center'
  | 'justify-start'
  | 'justify-end'
  | 'justify-end-safe'
  | 'justify-center-safe'
  | 'justify-around'
  | 'justify-evenly'
  | 'justify-stretch'
  | 'justify-baseline'
  | 'justify-normal'
/**
 * Design systems have stack component often. This is our version.
 * We can put set of items and control the layout.
 */
interface FlexContainerProps {
  children: React.ReactNode
  align?: Align
  justify?: Justify
  wrap?: boolean
  gap?: Gap
  className?: string
}

export const FlexContainer: React.FC<FlexContainerProps> = ({
  children,
  align = 'items-start',
  justify = 'justify-start',
  wrap = true,
  gap = 'gap-4',
  className = '',
}) => {
  return (
    <div
      className={`
        flex
        ${wrap ? 'flex-wrap' : 'flex-nowrap'}
        ${align}
        ${justify}
        ${gap}
        ${className}
      `}
    >
      {children}
    </div>
  )
}
